import { render, staticRenderFns } from "./wzbLeft.vue?vue&type=template&id=9939bc64&scoped=true&"
import script from "./wzbLeft.vue?vue&type=script&lang=js&"
export * from "./wzbLeft.vue?vue&type=script&lang=js&"
import style0 from "./wzbLeft.vue?vue&type=style&index=0&id=9939bc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9939bc64",
  null
  
)

export default component.exports